import { render, staticRenderFns } from "./thomas-tech-report.vue?vue&type=template&id=18ae00cd&scoped=true&"
import script from "./js/thomas-tech-report.js?vue&type=script&lang=js&"
export * from "./js/thomas-tech-report.js?vue&type=script&lang=js&"
import style0 from "./thomas-tech-report.vue?vue&type=style&index=0&id=18ae00cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae00cd",
  null
  
)

export default component.exports